export default class extends Error {
	isHandled = false;
	request = undefined;
	response = undefined;
	responseMessage = undefined;
	responseData = undefined;

	constructor (request, response) {
		const responseMessage = response?.data?.data?.message ?? response?.data?.message ?? 'Unknown Error';
		super(responseMessage);

		this.responseMessage = responseMessage;
		this.responseData = response?.data?.data ?? response?.data ?? response;

		this.request = request;
		this.response = response;
	}

	toLowerCase () {
		return this.responseMessage.toLowerCase();
	}

	includes (...a) {
		return this.responseMessage.includes(...a);
	}

	getErrorString () {
		if (typeof this.responseData === 'object') {
			let message = '';
			Object.keys(this.responseData).forEach(key => {
				if (typeof this.responseData[key] !== 'object') {
					message += this.responseData[key] + '\n';
					return;
				}
				Object.keys(this.responseData[key]).forEach(key2 => {
					message += this.responseData[key][key2] + '\n';
				});
			});
			return message;
		}
		return this.responseMessage;
	}
}
